export const ROUTE_NAMES = {
    HOMEPAGE: 'index',
    AUCTION_LISTING: 'auctions-localizedAssetType-optionalParams',
    AUCTION_DETAIL: 'auctions-dp-slug',
    DIRECT_SALE_LISTING: 'direct-sales-localizedAssetType-optionalParams',
    DIRECT_SALE_DETAIL: 'direct-sales-dp-slug',
    DIRECT_SALE_DETAIL_NEGOTIATION: 'direct-sales-dp-slug-negotiation',

    // Login & signup
    LOGIN: 'login',
    SIGNUP: 'signup',
    SIGNUP_CONFIRM: 'signup-confirm',
    PASSWORD_RESET: 'password-reset',

    // Content
    COOKIE_POLICY: 'cookie-policy',
    PRIVACY_POLICY: 'privacy-policy',
    TERMS_AND_CONDITIONS: 'terms-and-conditions',
    LOGISTICS_TERMS_AND_CONDITIONS: 'logistics-terms-and-conditions',
    FAQ: 'faq',
    PRICING_BUYER: 'pricing-buyer',
    PRICING_SELLER: 'pricing-seller',
    ACCESSIBILITY_STATEMENT: 'accessibility-statement',
    HOW_TO_HOW_SELL_USED_BUS: 'how-to-how-sell-used-bus',
    HOW_TO_REASONS_BUY_BUS_AUCTION: 'how-to-reasons-buy-bus-auction',
    HOW_TO_GUIDE_BUY_USED_BUS: 'how-to-guide-buy-used-bus',
    HOW_TO_TRUST_REPORT: 'how-to-trust-report',
    BLACK_WEEK: 'black-week',

    // Account
    ACCOUNT_BIDS: 'account-bids',
    ACCOUNT_PROFILE: 'account-profile',
    ACCOUNT_YOUR_AUCTIONS: 'account-your-auctions',
    ACCOUNT_YOUR_DIRECT_SALE_BUYER_NEGOTIATIONS: 'account-your-direct-sale-buyer-negotiations',
    ACCOUNT_YOUR_DIRECT_SALES: 'account-your-direct-sales',
    ACCOUNT_ORDERS_AUCTION: 'account-orders-auction',
    ACCOUNT_ORDERS: 'account-orders',
    ACCOUNT_ORDER: 'account-orders-id',
    ACCOUNT_ORDER_THANK_YOU: 'account-orders-id-thank-you',
    ACCOUNT_ORDER_EDIT: 'account-orders-id-edit',
    ACCOUNT_ORDER_EDIT_PAYMENT: 'account-orders-id-edit-payment',
    ACCOUNT_PAYMENT_METHODS: 'account-payment-methods',

    // Smart links
    SMART_LINK_VEHICLE: 'go-v-vin',
} as const;

export const SLP_ROUTE_NAMES = [ROUTE_NAMES.AUCTION_LISTING, ROUTE_NAMES.DIRECT_SALE_LISTING] as const;

export const SDP_ROUTE_NAMES = [ROUTE_NAMES.AUCTION_DETAIL, ROUTE_NAMES.DIRECT_SALE_DETAIL, ROUTE_NAMES.DIRECT_SALE_DETAIL_NEGOTIATION] as const;

export type RouteName = (typeof ROUTE_NAMES)[keyof typeof ROUTE_NAMES];

export type SlpRouteName = (typeof SLP_ROUTE_NAMES)[number];

export type SdpRouteName = (typeof SDP_ROUTE_NAMES)[number];
